<script>
  import Markdown from "svelte-markdown";

  import UAParser from "ua-parser-js";
  let parser = new UAParser();
  let os = parser.getOS();

  import { getContext, onMount } from "svelte";
  const { close } = getContext("simple-modal");
  const tourUrl = "https://tours.covecreekproductions.com/toledo_map/";
  import { tourFunctions } from "../tour-functions";

  // Icons
  import IconDirections from "./IconDirections.svelte";
  import IconWalk from "./IconWalk.svelte";
  import IconCar from "./IconCar.svelte";
  import Icon360 from "./Icon360.svelte";

  // Exports
  export let image;
  export let title;
  export let content;
  export let linkedscenes = [];
  export let driveLocation;
  export let walkLocation;
  export let directions;

  const directionsUrl = generateMapUrl(directions, "walking");
  const walkUrl = generateMapUrl(walkLocation, "walking");
  const driveUrl = generateMapUrl(driveLocation, "driving");

  if (linkedscenes) {
    linkedscenes.forEach((s) => {
      s.url = `${tourUrl}?startscene=${s.name}`;
    });
  }

  function generateMapUrl(location, transportation) {
    if (!location) {
      return;
    }
    const baseUrl = "https://www.google.com/maps/dir/";
    const coordinates = `${location.lat},${location.lng}`;

    if (os.name === "iOS") {
      return `http://maps.apple.com/?daddr=${coordinates}&t=s`;
    } else {
      let travelMode;

      if (transportation === "walking") {
        travelMode = "data=!3m1!4b1!4m2!4m1!3e2";
      } else if (transportation === "driving") {
        travelMode = "data=!4m2!4m1!3e0";
      } else {
        travelMode = "";
      }

      return `${baseUrl}${coordinates}/@${coordinates},12z/${travelMode}`;
    }
  }

  function loadScene(sceneName) {
    console.log("loadScene", sceneName);
    console.log(window.CC);
    tourFunctions.loadScene(sceneName);
    if (window.CC.switchView) {
      window.CC.switchView();
    }
    close();
  }
</script>

<div class="popup">
  <!-- {#if image}
  <div class="image column" style={`background-image: url(${image});`}></div>
  {/if} -->

  <div class="content column">
    <div class="content-header">
      <h2 class="title">{title}</h2>
    </div>
    <div class="actions" class:wide={linkedscenes.length > 1}>
      <!-- Walking Link -->
      {#if walkLocation}
        <a class="link icon-text" href={walkUrl} target={"_blank"}>
          <div class="icon-container">
            <IconWalk size={"0.65em"} fill="#fff" />
          </div>
          <span>Walk to this location</span>
        </a>
      {/if}
      <!-- Driving Link -->
      {#if driveLocation}
        <a class="link icon-text" href={driveUrl} target={"_blank"}>
          <div class="icon-container">
            <IconCar size={"1.5em"} fill="#fff" />
          </div>
          <span>Drive to this location</span>
        </a>
      {/if}
      <!-- Directions Link -->
      {#if directions}
        <a class="link icon-text" href={directionsUrl} target={"_blank"}>
          <div class="icon-container">
            <IconDirections size={"1.5em"} fill="#fff" />
          </div>
          <span>Directions to this location</span>
        </a>
      {/if}
      <!-- 360 Pano Link Multiple -->
      {#if linkedscenes.length > 1}
        <div class="linkedscenes">
          <h3 class="icon-text">
            <div class="icon-container">
              <Icon360 fill="#fff" size={"1.5em"} />
            </div>
            <span>Open in Virtual Tour:</span>
          </h3>

          <ul>
            {#each linkedscenes as ls}
              <li>
                <a
                  class="link"
                  on:click={() => {
                    loadScene(`${ls.name}`);
                  }}
                >
                  {ls.title}
                </a>
              </li>
            {/each}
          </ul>
        </div>
      {/if}
      <!-- 360 Pano Link Single -->
      {#if linkedscenes.length == 1}
        <a
          class="link icon-text"
          on:click={() => {
            loadScene(`${linkedscenes[0].name}`);
          }}
        >
          <div class="icon-container">
            <Icon360 fill="#fff" size={"1.5em"} />
          </div>
          <span>Open in Virtual Tour</span>
        </a>
      {/if}
    </div>
    {#if content}
      <div class="content-inner">
        <Markdown source={content} />
      </div>
    {/if}
  </div>
</div>

<style>
  .popup {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    font-family: var(--font-body), sans-serif;
  }

  .column {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
    height: 100%;
  }

  .image {
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  .content {
    justify-content: center;
    align-items: center;
    /* text-align: center; */
  }

  .content-header {
    padding: 0 1rem;
  }

  .content-inner {
    text-align: left;
    line-height: 1.65em;
    padding: 0 1rem;
    overflow-y: scroll;
    max-height: 400px;
  }

  :global(.popup .content-inner a) {
    color: #fff;
    font-weight: 500;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: #fff;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ddd;
  }

  a {
    color: #fff;
    text-decoration: underline;
  }

  a:hover,
  a:hover span {
    font-weight: bold;
  }

  .actions {
    padding: 0;
  }

  .actions.wide {
    width: calc(100% - 2rem);
  }

  .title {
    font-size: 2rem;
    font-weight: 900;
    margin: 0;
    margin-bottom: 0.25em;
  }

  .button {
    background: #000;
    padding: 0.75rem;
    color: #fff;
    border-radius: 5px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .button:hover {
    background: #333;
  }

  .button span {
    margin-left: 0.5em;
  }

  .link {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .icon-text {
    display: inline-flex;
    align-items: center;
  }

  .icon-text span {
    margin: 0 0.5em;
    font-weight: 500;
  }

  .icon-container {
    width: 1.5em;
    height: 1.5em;
    text-align: center;
  }

  .linkedscenes {
    /* padding: 0 0 1em 0; */
    padding: 0;
    display: block;
    vertical-align: middle;
  }

  .linkedscenes h3 {
    margin-bottom: 0.25em;
  }

  .linkedscenes ul {
    padding-left: 40px;
    list-style: none;
    margin: 0;
  }

  .linkedscenes li {
    margin-bottom: 0.5em;
  }

  @media (max-width: 768px) {
    .title {
      font-size: 1.5em;
    }
  }
</style>
